import { atom } from "recoil";

const usersLoading = atom({
  key: 'users-loading',
  default: true,
});

const usersCurrentPage = atom({
  key: 'users-current-page',
  default: 1,
});

const usersSearch = atom({
  key: 'users-search',
  default: '',
});

const usersData = atom({
  key: 'users-data',
  default: {},
});

export {
  usersLoading,
  usersCurrentPage,
  usersSearch,
  usersData
}